import { log_out } from '@assets/images';
import { hfw_logo } from '@assets/svg';
import { NavLink, useNavigate } from '@remix-run/react';
import React, { useEffect, useState } from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import { HeaderProps } from '@models/ui';
import './header.css';
import { BrowserCustomerClient } from '@client';
import { NotificationEventMessage } from '@models/api';
import { format } from 'date-fns';
import { mixpanelService } from '@utilities';

// export default function Header({ loaderData }: { loaderData: { isLoggedIn: boolean; mixpanelId: string; position: string; customerName?: string, showManageEvaluations?: boolean } }) {
interface InternalCommonHeaderProps {
  handleStartEvaluationClick: () => void;
  handleLoginClick: () => void;
  handleLogoClick: () => void;
}
interface ShowSubcribedUserProps {
  headerProps: HeaderProps;
  handleLogoClick: () => void;
  onSubmit: (event: { preventDefault: () => void }) => Promise<void>;
}
interface ShowUnsubcribedUserProps {
  headerProps: HeaderProps;
  handleLogoClick: () => void;
  handleStartEvaluationClick: () => void;
  onSubmit: (event: { preventDefault: () => void }) => Promise<void>;
}
const Header: React.FC<{ headerProps: HeaderProps }> = ({ headerProps }) => {
  // const [isOpen, setIsOpen] = useState<boolean>(false);

  /* useEffect(() => {
    // This function will be called when user navigates away (including back button)
    const handleNavigation = (event: PopStateEvent) => {
      // Use fetcher to call your cookie-clearing endpoint
      
    };

    // Add event listener for the 'popstate' event (triggered by back/forward navigation)
    window.addEventListener('popstate', handleNavigation);

    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener('popstate', handleNavigation);
    };
  }, []); */

  const navigate = useNavigate();

  const handleStartEvaluationClick = () => {
    // setIsOpen(true);    
    mixpanelService.track('start_assessment_cta_click', {
      position: headerProps.position,
    });
    navigate('/assessment');
  };

  /*  const handleManageEvaluationClick = () => {
     navigate("/account");
   }; */

  const handleLoginClick = () => {
    mixpanelService.track('login_cta_click', {
      position: headerProps.position,
    });
  };

  const handleLogoClick = () => {
    localStorage.setItem('position', 'header');
    navigate('/');
  };

  const onSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    mixpanelService.track('logout_cta_click', {
      position: headerProps.position,
    });
    mixpanelService.reset();

    /* const client = new BrowserIdentityClient();
    const response = await client?.Logout(); */
    // setLoggedIn(false);

    navigate('/logout');
  };

  /* const handlePopupClose = () => {
    setIsOpen(false);
  }; */

  let header = <ShowPreLoginHeader handleLoginClick={handleLoginClick} handleLogoClick={handleLogoClick} handleStartEvaluationClick={handleStartEvaluationClick} />;

  if (headerProps.isLoggedIn && !headerProps.isSubscribed)
    header = <ShowUnsubscribedUserHeader handleLogoClick={handleLogoClick} handleStartEvaluationClick={handleStartEvaluationClick} headerProps={headerProps} onSubmit={onSubmit} />;

  if (headerProps.isLoggedIn && headerProps.isSubscribed) header = <ShowSubscribedUserHeader handleLogoClick={handleLogoClick} onSubmit={onSubmit} headerProps={headerProps} />;

  return header;
};

export default Header;

const ShowPreLoginHeader: React.FC<InternalCommonHeaderProps> = ({ handleLogoClick, handleLoginClick, handleStartEvaluationClick }) => {
  return (
    <div className="loader-opacity-header w-[90%] px-4 py-6 flex items-center gap-x-2">
      <button onClick={handleLogoClick}>
        <img src={hfw_logo} alt="logo" className="max-w-96 ml-24 h-9" />
      </button>
      <span className="flex-1"></span>
      <NavLink className="header-login-btn" to="/login" onClick={handleLoginClick}>
        Log In
      </NavLink>

      <button className="btn btn-brand-outline-animated rounded-lg shadow-sm cta-button" onClick={handleStartEvaluationClick}>
        Explore
      </button>

      <NavLink to="/subscribe" className="header-start-assessment" onClick={() => {
        mixpanelService.track('direct_subscribe_cta_click', {
          position: 'header'
        });
      }} reloadDocument>
        Subscribe
      </NavLink>
    </div>
  );
};

const ShowUnsubscribedUserHeader: React.FC<ShowUnsubcribedUserProps> = ({ handleLogoClick, handleStartEvaluationClick, headerProps, onSubmit }) => {
  const [profileImage, setProfileImage] = useState<string>('');

  useEffect(() => {
    if (headerProps.isLoggedIn) {
      if (headerProps.customerImageUrl === '') {
        return;
      }

      if (headerProps.customerImageUrl !== '') {
        (async () => {
          const client = new BrowserCustomerClient();
          const profileImgResp = await client.GetBucketFileUrl({ key: headerProps.customerImageUrl ?? '' });
          const profileImgUrl = profileImgResp.data;
          setProfileImage(profileImgUrl);
        })();
      }
    }
  }, [headerProps]);

  return (
    <div className="loader-opacity-header w-[90%] px-4 py-6 flex items-center gap-x-2">
      <button onClick={handleLogoClick}>
        <img src={hfw_logo} alt="logo" className="max-w-96 ml-24 h-9" />
      </button>
      <span className="flex-1"></span>

      <button className="btn btn-brand-outline-animated rounded-lg shadow-sm cta-button" onClick={handleStartEvaluationClick}>
        Explore
      </button>

      <NavLink to="/subscribe" className="header-start-assessment" onClick={() => {
        mixpanelService.track('direct_subscribe_cta_click', {
          position: 'header'
        });
      }} reloadDocument>
        Subscribe
      </NavLink>

      <Menu as="div" className="relative flex gap-x-4 pl-[16px]">
        <MenuButton>
          <div className="w-[40px] h-[40px] bg-[#004E98] rounded-3xl flex items-center justify-center ">
            {profileImage !== '' ? (
              <img src={profileImage} alt="profile_img" className="w-[40px] h-[40px] rounded-3xl" />
            ) : (
              <p className="text-white text-lg font-semibold cursor-pointer"> {headerProps.customerName ? headerProps.customerName[0].toUpperCase() : 'U'} </p>
            )}
          </div>
        </MenuButton>

        <MenuItems className="absolute right-0 z-20 rounded-xl bg-white shadow-lg p-6 translate-y-16">
          <div className="flex flex-col gap-y-1 items-start">
            <NavLink to="/assessment" className="flex px-4 py-2 items-center justify-center gap-[10px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
                <path
                  d="M16.0251 8.68368C16.2113 8.82107 16.3668 8.99672 16.4806 9.19944C16.6181 9.44425 16.6903 9.72031 16.6903 10.0011C16.6903 10.2819 16.6181 10.5579 16.4806 10.8027C16.3432 11.0474 16.1452 11.2527 15.9056 11.3988L16.0251 8.68368ZM16.0251 8.68368V8.67474L15.9056 8.60161L3.26435 0.86842C3.26432 0.868401 3.26429 0.868382 3.26425 0.868362C3.01319 0.714649 2.72565 0.630734 2.43132 0.625284C2.13706 0.619834 1.84668 0.693008 1.59015 0.837251C1.33577 0.979543 1.12387 1.187 0.976216 1.4383C0.828507 1.6897 0.750426 1.9759 0.75 2.26748V2.26784L0.749998 17.7326L0.750002 17.7337C0.751919 18.1707 0.927303 18.5891 1.2376 18.8969C1.54778 19.2046 1.9674 19.3765 2.40428 19.375M16.0251 8.68368L15.9052 11.399L3.26779 19.132L3.26747 19.1322C3.00745 19.2908 2.70882 19.3748 2.40428 19.375M2.40428 19.375C2.40416 19.375 2.40404 19.375 2.40392 19.375L2.40381 19.125L2.40475 19.375C2.40459 19.375 2.40444 19.375 2.40428 19.375ZM2.65381 17.27V2.72529L14.5441 10.0001L2.65381 17.27Z"
                  fill="#667085"
                  stroke="#667085"
                  strokeWidth="0.5"
                />
              </svg>
              <p className="text-[#667085] font-semibold text-base text-nowrap"> Start New Evaluation </p>
            </NavLink>
          </div>

          <div className="flex flex-col items-center gap-y-1">
            <NavLink to="/account/profile" className="flex px-4 py-2 items-center justify-center gap-[10px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433285 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9972 7.3487 18.9427 4.80678 17.068 2.93202C15.1932 1.05727 12.6513 0.00279983 10 0ZM4.81539 16.6827C5.37187 15.8124 6.13847 15.0962 7.04454 14.6001C7.95062 14.1039 8.967 13.8439 10 13.8439C11.033 13.8439 12.0494 14.1039 12.9555 14.6001C13.8615 15.0962 14.6281 15.8124 15.1846 16.6827C13.7023 17.8356 11.8779 18.4615 10 18.4615C8.1221 18.4615 6.29776 17.8356 4.81539 16.6827ZM6.92308 9.23077C6.92308 8.62221 7.10354 8.02732 7.44164 7.52132C7.77973 7.01533 8.26028 6.62095 8.82252 6.38806C9.38475 6.15518 10.0034 6.09424 10.6003 6.21297C11.1971 6.33169 11.7454 6.62474 12.1757 7.05506C12.606 7.48537 12.8991 8.03363 13.0178 8.63049C13.1365 9.22736 13.0756 9.84602 12.8427 10.4083C12.6098 10.9705 12.2154 11.451 11.7095 11.7891C11.2035 12.1272 10.6086 12.3077 10 12.3077C9.18395 12.3077 8.40133 11.9835 7.82429 11.4065C7.24726 10.8294 6.92308 10.0468 6.92308 9.23077ZM16.3231 15.6163C15.4652 14.3732 14.2588 13.4114 12.8558 12.8519C13.6094 12.2583 14.1594 11.4446 14.4292 10.5239C14.6989 9.60328 14.6751 8.62144 14.361 7.71495C14.0469 6.80846 13.4581 6.02239 12.6765 5.46605C11.8949 4.90971 10.9594 4.61075 10 4.61075C9.04064 4.61075 8.10511 4.90971 7.32353 5.46605C6.54194 6.02239 5.95315 6.80846 5.63903 7.71495C5.32491 8.62144 5.30108 9.60328 5.57084 10.5239C5.84061 11.4446 6.39057 12.2583 7.14424 12.8519C5.74118 13.4114 4.53484 14.3732 3.67693 15.6163C2.59286 14.3973 1.8843 12.8908 1.63659 11.2784C1.38887 9.66592 1.61255 8.01624 2.28069 6.52798C2.94884 5.03972 4.03296 3.77632 5.40251 2.88994C6.77206 2.00355 8.36864 1.53197 10 1.53197C11.6314 1.53197 13.228 2.00355 14.5975 2.88994C15.9671 3.77632 17.0512 5.03972 17.7193 6.52798C18.3875 8.01624 18.6111 9.66592 18.3634 11.2784C18.1157 12.8908 17.4072 14.3973 16.3231 15.6163Z"
                  fill="#667085"
                />
              </svg>
              <p className="text-[#667085] font-semibold text-base text-nowrap"> Manage Your Profile </p>
            </NavLink>
          </div>

          <div className="flex flex-col items-start gap-y-1">
            <NavLink to="/knowledge-hub/resources/videos" className="flex px-4 py-2 items-center justify-center gap-[10px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                <path
                  d="M18.9659 17.0549L15.6814 1.2742C15.6389 1.06784 15.5565 0.871985 15.4389 0.6979C15.3213 0.523815 15.1708 0.374928 14.996 0.259792C14.8213 0.144656 14.6258 0.0655395 14.4208 0.0269886C14.2157 -0.0115624 14.0051 -0.0087884 13.8011 0.0351512L9.16873 1.04119C8.75899 1.13186 8.40123 1.38234 8.17329 1.73817C7.94534 2.09399 7.86564 2.52638 7.95151 2.94127L11.236 18.7219C11.3092 19.082 11.5029 19.4056 11.7844 19.6383C12.0659 19.8711 12.4181 19.9988 12.7818 20C12.8942 19.9998 13.0063 19.9877 13.1163 19.964L17.7487 18.958C18.1589 18.8671 18.517 18.6161 18.745 18.2597C18.973 17.9032 19.0524 17.4702 18.9659 17.0549ZM9.50025 2.61426V2.60526L14.1316 1.60522L14.4612 3.19229L9.82979 4.19933L9.50025 2.61426ZM10.1554 5.76139L14.7887 4.75635L15.1193 6.34642L10.4899 7.35246L10.1554 5.76139ZM10.8125 8.91853L15.4458 7.91249L16.762 14.2368L12.1287 15.2428L10.8125 8.91853ZM17.4171 17.3939L12.7858 18.3939L12.4562 16.8069L17.0876 15.7998L17.4171 17.3849V17.3939ZM6.3335 0.799184H1.58338C1.16344 0.799184 0.7607 0.967762 0.46376 1.26783C0.166819 1.5679 0 1.97489 0 2.39925V18.3999C0 18.8243 0.166819 19.2313 0.46376 19.5314C0.7607 19.8314 1.16344 20 1.58338 20H6.3335C6.75344 20 7.15618 19.8314 7.45312 19.5314C7.75006 19.2313 7.91688 18.8243 7.91688 18.3999V2.39925C7.91688 1.97489 7.75006 1.5679 7.45312 1.26783C7.15618 0.967762 6.75344 0.799184 6.3335 0.799184ZM1.58338 2.39925H6.3335V3.99932H1.58338V2.39925ZM1.58338 5.59939H6.3335V15.1998H1.58338V5.59939ZM6.3335 18.3999H1.58338V16.7999H6.3335V18.3999Z"
                  fill="#667085"
                />
              </svg>
              <p className="text-[#667085] font-semibold text-base text-nowrap"> Knowledge hub </p>
            </NavLink>
          </div>

          <button className="header-login-btn" onClick={onSubmit}>
            <div className="flex gap-x-[10px] items-center">
              <img className="w-[18px] h-[18px]" src={log_out} alt="log_out" />
              <p className="text-[#667085] font-semibold text-base">Log Out</p>
            </div>
          </button>
        </MenuItems>
      </Menu>
    </div>
  );
};

const ShowSubscribedUserHeader: React.FC<ShowSubcribedUserProps> = ({ handleLogoClick, onSubmit, headerProps }) => {
  // const client = useIdentityAPIClient();
  const [profileImage, setProfileImage] = useState<string>('');

  useEffect(() => {
    if (headerProps.isLoggedIn) {
      if (headerProps.customerImageUrl === '') {
        return;
      }

      if (headerProps.customerImageUrl !== '') {
        (async () => {
          const client = new BrowserCustomerClient();
          const profileImgResp = await client.GetBucketFileUrl({ key: headerProps.customerImageUrl ?? '' });
          const profileImgUrl = profileImgResp.data;
          setProfileImage(profileImgUrl);
        })();
      }
    }
  }, [headerProps]);

  // const notificationContext = useDisplayNotifications();
  // const notifications = notificationContext.notifications;
  // const notifications = [];
  const [notifications, setNotifications] = useState<NotificationEventMessage[]>([]);
  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    if (!headerProps.isLoggedIn) {
      return;
    }

    (async () => {
      intervalId = setInterval(async () => {
        if (!headerProps.isLoggedIn) {
          return;
        }
        const client = new BrowserCustomerClient();
        const initialNotificationsResp = await client.GetNotifications();
        const initialNotifications = initialNotificationsResp.data;
        // console.log('Received initial notifications:', initialNotifications);
        setNotifications(initialNotifications);
      }, 5000);
    })();

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="loader-opacity-header w-full px-32">
      <div className="py-6 flex items-center justify-between">
        <button onClick={handleLogoClick}>
          <img src={hfw_logo} alt="logo" className="max-w-96 h-9" />
        </button>
        <span className="flex-1"></span>

        <Menu as="div" className="relative flex gap-x-4">
          <div className="flex gap-x-4 items-center justify-center">
            {headerProps.showManageEvaluations ? (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <NavLink to="/account" className="header-start-assessment text-nowrap cursor-pointer" reloadDocument>
                Manage Evaluation
              </NavLink>
            ) : (
              ''
            )}
          </div>

          <MenuButton>
            {notifications.length > 0 ? (
              <svg className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                <path
                  d="M14.8749 22.4999C14.8749 22.732 14.7827 22.9546 14.6186 23.1187C14.4545 23.2827 14.232 23.3749 13.9999 23.3749H6.99999C6.76792 23.3749 6.54537 23.2827 6.38128 23.1187C6.21718 22.9546 6.125 22.732 6.125 22.4999C6.125 22.2679 6.21718 22.0453 6.38128 21.8812C6.54537 21.7171 6.76792 21.625 6.99999 21.625H13.9999C14.232 21.625 14.4545 21.7171 14.6186 21.8812C14.7827 22.0453 14.8749 22.2679 14.8749 22.4999ZM20.7646 19C20.6128 19.2674 20.3924 19.4895 20.1261 19.6433C19.8598 19.7971 19.5573 19.8771 19.2498 19.875H1.75006C1.44243 19.8746 1.14035 19.7931 0.874255 19.6387C0.608164 19.4843 0.387469 19.2625 0.234412 18.9957C0.0813563 18.7288 0.00134839 18.4264 0.00245268 18.1187C0.00355698 17.8111 0.0857346 17.5092 0.240703 17.2435C0.847726 16.1978 1.75006 13.2404 1.75006 9.37512C1.75006 7.05451 2.67192 4.82895 4.31284 3.18802C5.95376 1.5471 8.17933 0.625244 10.4999 0.625244C12.8205 0.625244 15.0461 1.5471 16.687 3.18802C18.328 4.82895 19.2498 7.05451 19.2498 9.37512C19.2498 13.2393 20.1532 16.1978 20.7603 17.2435C20.9168 17.5096 20.9996 17.8126 21.0002 18.1213C21.0007 18.43 20.9191 18.7333 20.7635 19H20.7646ZM19.2498 18.125C18.4044 16.6736 17.4998 13.318 17.4998 9.37512C17.4998 7.51863 16.7624 5.73818 15.4496 4.42544C14.1369 3.11271 12.3564 2.37522 10.4999 2.37522C8.64345 2.37522 6.86299 3.11271 5.55026 4.42544C4.23752 5.73818 3.50003 7.51863 3.50003 9.37512C3.50003 13.3191 2.59442 16.6747 1.75006 18.125H19.2498Z"
                  fill="black"
                />
                <circle cx="17.0002" cy="5" r="3.5" fill="#FF5757" stroke="white" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                <path
                  d="M15.6644 16.25C15.9428 16.2518 16.2168 16.1793 16.458 16.04C16.6994 15.9006 16.8992 15.6992 17.0368 15.4568L17.2488 15.0833H17.1926C17.23 14.9471 17.2491 14.8059 17.2489 14.6634C17.2483 14.384 17.1735 14.1099 17.0321 13.8691C16.5986 13.1221 15.9152 10.9158 15.9152 7.99983C15.9152 6.16538 15.1865 4.40606 13.8893 3.1089C12.5922 1.81174 10.8328 1.08301 8.99839 1.08301C7.16394 1.08301 5.40461 1.81174 4.10746 3.1089C2.8103 4.40606 2.08157 6.16538 2.08157 7.99983C2.08157 10.9172 1.39874 13.1229 0.965332 13.8695L1.18154 13.995M15.6644 16.25C15.6641 16.25 15.6638 16.25 15.6635 16.25L15.6652 16M15.6644 16.25H15.6652V16M15.6644 16.25H2.33157H2.33123C2.05289 16.2496 1.77957 16.1759 1.53881 16.0362C1.29805 15.8966 1.09837 15.6959 0.959886 15.4544C0.821402 15.213 0.749011 14.9393 0.75001 14.661C0.751009 14.3826 0.825363 14.1095 0.965577 13.869L1.18154 13.995M15.6652 16C15.8995 16.0016 16.13 15.9407 16.3329 15.8235C16.4455 15.7585 16.5473 15.6774 16.6354 15.5833L1.18154 13.995M15.6652 16H2.33157C2.09717 15.9997 1.86701 15.9376 1.66426 15.82C1.46152 15.7024 1.29337 15.5334 1.17675 15.3301C1.06013 15.1267 0.999167 14.8963 1.00001 14.6619C1.00085 14.4275 1.06346 14.1975 1.18154 13.995M12.3133 18.6483C12.4852 18.4764 12.5818 18.2432 12.5818 18.0001C12.5818 17.757 12.4852 17.5238 12.3133 17.3519C12.1414 17.18 11.9082 17.0834 11.6651 17.0834H6.33166C6.08854 17.0834 5.85538 17.18 5.68347 17.3519C5.51156 17.5238 5.41498 17.757 5.41498 18.0001C5.41498 18.2432 5.51156 18.4764 5.68347 18.6483C5.85538 18.8202 6.08854 18.9168 6.33166 18.9168H11.6651C11.9082 18.9168 12.1414 18.8202 12.3133 18.6483ZM14.0819 7.99983C14.0819 10.7369 14.6474 13.127 15.2535 14.4167H2.74315C3.3487 13.1276 3.91493 10.7376 3.91493 7.99983C3.91493 6.65162 4.45051 5.35862 5.40384 4.40528C6.35718 3.45195 7.65018 2.91637 8.99839 2.91637C10.3466 2.91637 11.6396 3.45195 12.5929 4.40528C13.5463 5.35862 14.0819 6.65162 14.0819 7.99983Z"
                  fill="#667085"
                  stroke="#667085"
                  strokeWidth="0.5"
                />
              </svg>
            )}
          </MenuButton>

          <MenuItems className="absolute right-0 z-20 rounded-xl bg-white shadow-lg flex flex-col gap-y-3 w-[480px] h-[595px] p-6 items-start translate-y-16 border">
            <div className="flex gap-x-[10px] justify-center items-center px-[16px] py-[10px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                <path
                  d="M15.6644 16.25C15.9428 16.2518 16.2168 16.1793 16.458 16.04C16.6994 15.9006 16.8992 15.6992 17.0368 15.4568L17.2488 15.0833H17.1926C17.23 14.9471 17.2491 14.8059 17.2489 14.6634C17.2483 14.384 17.1735 14.1099 17.0321 13.8691C16.5986 13.1221 15.9152 10.9158 15.9152 7.99983C15.9152 6.16538 15.1865 4.40606 13.8893 3.1089C12.5922 1.81174 10.8328 1.08301 8.99839 1.08301C7.16394 1.08301 5.40461 1.81174 4.10746 3.1089C2.8103 4.40606 2.08157 6.16538 2.08157 7.99983C2.08157 10.9172 1.39874 13.1229 0.965332 13.8695L1.18154 13.995M15.6644 16.25C15.6641 16.25 15.6638 16.25 15.6635 16.25L15.6652 16M15.6644 16.25H15.6652V16M15.6644 16.25H2.33157H2.33123C2.05289 16.2496 1.77957 16.1759 1.53881 16.0362C1.29805 15.8966 1.09837 15.6959 0.959886 15.4544C0.821402 15.213 0.749011 14.9393 0.75001 14.661C0.751009 14.3826 0.825363 14.1095 0.965577 13.869L1.18154 13.995M15.6652 16C15.8995 16.0016 16.13 15.9407 16.3329 15.8235C16.4455 15.7585 16.5473 15.6774 16.6354 15.5833L1.18154 13.995M15.6652 16H2.33157C2.09717 15.9997 1.86701 15.9376 1.66426 15.82C1.46152 15.7024 1.29337 15.5334 1.17675 15.3301C1.06013 15.1267 0.999167 14.8963 1.00001 14.6619C1.00085 14.4275 1.06346 14.1975 1.18154 13.995M12.3133 18.6483C12.4852 18.4764 12.5818 18.2432 12.5818 18.0001C12.5818 17.757 12.4852 17.5238 12.3133 17.3519C12.1414 17.18 11.9082 17.0834 11.6651 17.0834H6.33166C6.08854 17.0834 5.85538 17.18 5.68347 17.3519C5.51156 17.5238 5.41498 17.757 5.41498 18.0001C5.41498 18.2432 5.51156 18.4764 5.68347 18.6483C5.85538 18.8202 6.08854 18.9168 6.33166 18.9168H11.6651C11.9082 18.9168 12.1414 18.8202 12.3133 18.6483ZM14.0819 7.99983C14.0819 10.7369 14.6474 13.127 15.2535 14.4167H2.74315C3.3487 13.1276 3.91493 10.7376 3.91493 7.99983C3.91493 6.65162 4.45051 5.35862 5.40384 4.40528C6.35718 3.45195 7.65018 2.91637 8.99839 2.91637C10.3466 2.91637 11.6396 3.45195 12.5929 4.40528C13.5463 5.35862 14.0819 6.65162 14.0819 7.99983Z"
                  fill="#667085"
                  stroke="#667085"
                  strokeWidth="0.5"
                />
              </svg>
              <p className=""> All Notifications </p>
            </div>

            {notifications.length > 0 ? (
              <div className="flex flex-col gap-y-0 overflow-scroll w-full">
                {notifications.map((item, index) => (
                  <div key={index}>
                    <div className="notification-div">
                      <div className="w-[40px] h-[40px] bg-[#004E98] rounded-3xl flex items-center justify-center ">
                        {profileImage !== '' ? (
                          // <img src={headerProps.customerImageUrl} alt="profile_img" className="w-[40px] h-[40px] rounded-3xl" />
                          <img src={profileImage} alt="profile_img" className="w-[40px] h-[40px] rounded-3xl" />
                        ) : (
                          <p className="text-white text-lg font-semibold cursor-pointer"> {headerProps.customerName ? headerProps.customerName[0].toUpperCase() : 'U'} </p>
                        )}
                      </div>

                      <div className="content-div">
                        <p className="title"> {item.title} </p>
                        {item.description && item.description.length !== 0 ? (
                          <div className="mid-div">
                            <div className="left-div" />
                            <p className="right-div"> &quot; {item.description} &quot; </p>
                          </div>
                        ) : (
                          ''
                        )}
                        <p className="date"> {format(item.createdAt / 1_000_000, 'MMM d, yyyy')} </p>
                      </div>
                    </div>

                    <div className="h-[1px] bg-[#E4E8EE] self-stretch" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col gap-y-2 justify-center items-center w-full h-full px-[16px] py-[40px]">
                <p className="text-[#1A1F36] text-center text-base font-medium self-stretch"> No Notification Yet </p>
                <p className="text-[#1A1F36] text-center text-sm font-normal">
                  {' '}
                  You have no notifications right now. <br /> Come back later.{' '}
                </p>
                <button className="header-start-assessment text-nowrap"> Refresh </button>
              </div>
            )}
          </MenuItems>
        </Menu>

        <Menu as="div" className="relative flex gap-x-4 pl-[16px]">
          <MenuButton>
            <div className="w-[40px] h-[40px] bg-[#004E98] rounded-3xl flex items-center justify-center ">
              {profileImage !== '' ? (
                <img src={profileImage} alt="profile_img" className="w-[40px] h-[40px] rounded-3xl" />
              ) : (
                <p className="text-white text-lg font-semibold cursor-pointer"> {headerProps.customerName ? headerProps.customerName[0].toUpperCase() : 'U'} </p>
              )}
            </div>
          </MenuButton>

          <MenuItems className="absolute right-0 z-20 rounded-xl bg-white shadow-lg p-6 translate-y-16">
            <div className="flex flex-col gap-y-1 items-start">
              <NavLink to="/assessment" className="flex px-4 py-2 items-center justify-center gap-[10px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
                  <path
                    d="M16.0251 8.68368C16.2113 8.82107 16.3668 8.99672 16.4806 9.19944C16.6181 9.44425 16.6903 9.72031 16.6903 10.0011C16.6903 10.2819 16.6181 10.5579 16.4806 10.8027C16.3432 11.0474 16.1452 11.2527 15.9056 11.3988L16.0251 8.68368ZM16.0251 8.68368V8.67474L15.9056 8.60161L3.26435 0.86842C3.26432 0.868401 3.26429 0.868382 3.26425 0.868362C3.01319 0.714649 2.72565 0.630734 2.43132 0.625284C2.13706 0.619834 1.84668 0.693008 1.59015 0.837251C1.33577 0.979543 1.12387 1.187 0.976216 1.4383C0.828507 1.6897 0.750426 1.9759 0.75 2.26748V2.26784L0.749998 17.7326L0.750002 17.7337C0.751919 18.1707 0.927303 18.5891 1.2376 18.8969C1.54778 19.2046 1.9674 19.3765 2.40428 19.375M16.0251 8.68368L15.9052 11.399L3.26779 19.132L3.26747 19.1322C3.00745 19.2908 2.70882 19.3748 2.40428 19.375M2.40428 19.375C2.40416 19.375 2.40404 19.375 2.40392 19.375L2.40381 19.125L2.40475 19.375C2.40459 19.375 2.40444 19.375 2.40428 19.375ZM2.65381 17.27V2.72529L14.5441 10.0001L2.65381 17.27Z"
                    fill="#667085"
                    stroke="#667085"
                    strokeWidth="0.5"
                  />
                </svg>
                <p className="text-[#667085] font-semibold text-base text-nowrap"> Start New Evaluation </p>
              </NavLink>
            </div>

            <div className="flex flex-col items-center gap-y-1">
              <NavLink to="/account/profile" className="flex px-4 py-2 items-center justify-center gap-[10px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433285 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9972 7.3487 18.9427 4.80678 17.068 2.93202C15.1932 1.05727 12.6513 0.00279983 10 0ZM4.81539 16.6827C5.37187 15.8124 6.13847 15.0962 7.04454 14.6001C7.95062 14.1039 8.967 13.8439 10 13.8439C11.033 13.8439 12.0494 14.1039 12.9555 14.6001C13.8615 15.0962 14.6281 15.8124 15.1846 16.6827C13.7023 17.8356 11.8779 18.4615 10 18.4615C8.1221 18.4615 6.29776 17.8356 4.81539 16.6827ZM6.92308 9.23077C6.92308 8.62221 7.10354 8.02732 7.44164 7.52132C7.77973 7.01533 8.26028 6.62095 8.82252 6.38806C9.38475 6.15518 10.0034 6.09424 10.6003 6.21297C11.1971 6.33169 11.7454 6.62474 12.1757 7.05506C12.606 7.48537 12.8991 8.03363 13.0178 8.63049C13.1365 9.22736 13.0756 9.84602 12.8427 10.4083C12.6098 10.9705 12.2154 11.451 11.7095 11.7891C11.2035 12.1272 10.6086 12.3077 10 12.3077C9.18395 12.3077 8.40133 11.9835 7.82429 11.4065C7.24726 10.8294 6.92308 10.0468 6.92308 9.23077ZM16.3231 15.6163C15.4652 14.3732 14.2588 13.4114 12.8558 12.8519C13.6094 12.2583 14.1594 11.4446 14.4292 10.5239C14.6989 9.60328 14.6751 8.62144 14.361 7.71495C14.0469 6.80846 13.4581 6.02239 12.6765 5.46605C11.8949 4.90971 10.9594 4.61075 10 4.61075C9.04064 4.61075 8.10511 4.90971 7.32353 5.46605C6.54194 6.02239 5.95315 6.80846 5.63903 7.71495C5.32491 8.62144 5.30108 9.60328 5.57084 10.5239C5.84061 11.4446 6.39057 12.2583 7.14424 12.8519C5.74118 13.4114 4.53484 14.3732 3.67693 15.6163C2.59286 14.3973 1.8843 12.8908 1.63659 11.2784C1.38887 9.66592 1.61255 8.01624 2.28069 6.52798C2.94884 5.03972 4.03296 3.77632 5.40251 2.88994C6.77206 2.00355 8.36864 1.53197 10 1.53197C11.6314 1.53197 13.228 2.00355 14.5975 2.88994C15.9671 3.77632 17.0512 5.03972 17.7193 6.52798C18.3875 8.01624 18.6111 9.66592 18.3634 11.2784C18.1157 12.8908 17.4072 14.3973 16.3231 15.6163Z"
                    fill="#667085"
                  />
                </svg>
                <p className="text-[#667085] font-semibold text-base text-nowrap"> Manage Your Profile </p>
              </NavLink>
            </div>

            <div className="flex flex-col items-start gap-y-1">
              <NavLink to="/knowledge-hub/resources/videos" className="flex px-4 py-2 items-center justify-center gap-[10px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                  <path
                    d="M18.9659 17.0549L15.6814 1.2742C15.6389 1.06784 15.5565 0.871985 15.4389 0.6979C15.3213 0.523815 15.1708 0.374928 14.996 0.259792C14.8213 0.144656 14.6258 0.0655395 14.4208 0.0269886C14.2157 -0.0115624 14.0051 -0.0087884 13.8011 0.0351512L9.16873 1.04119C8.75899 1.13186 8.40123 1.38234 8.17329 1.73817C7.94534 2.09399 7.86564 2.52638 7.95151 2.94127L11.236 18.7219C11.3092 19.082 11.5029 19.4056 11.7844 19.6383C12.0659 19.8711 12.4181 19.9988 12.7818 20C12.8942 19.9998 13.0063 19.9877 13.1163 19.964L17.7487 18.958C18.1589 18.8671 18.517 18.6161 18.745 18.2597C18.973 17.9032 19.0524 17.4702 18.9659 17.0549ZM9.50025 2.61426V2.60526L14.1316 1.60522L14.4612 3.19229L9.82979 4.19933L9.50025 2.61426ZM10.1554 5.76139L14.7887 4.75635L15.1193 6.34642L10.4899 7.35246L10.1554 5.76139ZM10.8125 8.91853L15.4458 7.91249L16.762 14.2368L12.1287 15.2428L10.8125 8.91853ZM17.4171 17.3939L12.7858 18.3939L12.4562 16.8069L17.0876 15.7998L17.4171 17.3849V17.3939ZM6.3335 0.799184H1.58338C1.16344 0.799184 0.7607 0.967762 0.46376 1.26783C0.166819 1.5679 0 1.97489 0 2.39925V18.3999C0 18.8243 0.166819 19.2313 0.46376 19.5314C0.7607 19.8314 1.16344 20 1.58338 20H6.3335C6.75344 20 7.15618 19.8314 7.45312 19.5314C7.75006 19.2313 7.91688 18.8243 7.91688 18.3999V2.39925C7.91688 1.97489 7.75006 1.5679 7.45312 1.26783C7.15618 0.967762 6.75344 0.799184 6.3335 0.799184ZM1.58338 2.39925H6.3335V3.99932H1.58338V2.39925ZM1.58338 5.59939H6.3335V15.1998H1.58338V5.59939ZM6.3335 18.3999H1.58338V16.7999H6.3335V18.3999Z"
                    fill="#667085"
                  />
                </svg>
                <p className="text-[#667085] font-semibold text-base text-nowrap"> Knowledge hub </p>
              </NavLink>
            </div>

            <button className="header-login-btn" onClick={onSubmit}>
              <div className="flex gap-x-[10px] items-center">
                <img className="w-[18px] h-[18px]" src={log_out} alt="log_out" />
                <p className="text-[#667085] font-semibold text-base">Log Out</p>
              </div>
            </button>
          </MenuItems>
        </Menu>
      </div>
    </div>
  );
};
